module.exports = __webpack_public_path__ + "static/media/netlify.ecb5ec57.svg";